export interface Founder {
  id: string
  company: string
  founder: string
  sector: string
  image?: string
  imageType?: 'headshot' | 'logo'
  logo?: string
  logoScale?: 'default' | 'large'
  website?: string
}

export const founders: Founder[] = [
  {
    id: '16',
    company: 'Abimbola',
    founder: 'Mariam Oyinloye',
    sector: 'FemTech',
    image:
      'https://cdn.magicpatterns.com/uploads/v7YnUtTU9vdNoptwy9qGKS/c-PersonalMariamOyinloye__B7E10F81B2FA4D15A337FA42C5202B74_1700885431051.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/2sHsmKZPrzapF5CWZ7En6w/abimbola_logo.png',
    logoScale: 'large',
    website: 'https://www.abimbola.shop/',
  },
  {
    id: '17',
    company: 'Cotriply',
    founder: 'Faith Oloruntoba',
    sector: 'AI & SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/fBuotdGpxxmR5LjFLZiVGo/Screenshot_2026-03-25_at_10.20.10_PM.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/ssisuVp8mPSpTWnkvfWyLP/cortriply.png',
    logoScale: 'large',
    website: 'https://cotriply.ai/',
  },
  {
    id: '3',
    company: 'Diaminate',
    founder: 'Sarra Ali',
    sector: 'SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/qbhZpA5WhQqgUuSyZTgJ3K/Sarra.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/t4ZzhCw5JYazEUBPHoat3n/diaminate.png',
    logoScale: 'large',
    website: 'https://diaminate.com/',
  },
  {
    id: '15',
    company: 'GeneLene360',
    founder: 'Phyllis Pobee',
    sector: 'MedTech',
    image:
      'https://cdn.magicpatterns.com/uploads/9aYbPpgZFPtzjmLgE6KRaF/GeneLean360.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/u9J3WGmrKG4hLSGycWWdxY/genelean360.png',
    website: 'https://genelean360.com/lander-1',
  },
  {
    id: '5',
    company: 'Green Fuel',
    founder: 'Tola Oyin-Alabi',
    sector: 'Clean Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/hrAAfegMYbE354Gxpxrqjp/Tola_Green_Fuel.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/oiCmGoBqPiwQpCBQkSTbRg/greenfuel.png',
    website: 'https://greensubsidiaries.ca/about/',
  },
  {
    id: '6',
    company: 'Helius Originals',
    founder: 'Bilqees Grant',
    sector: 'Consumer Technology',
    image:
      'https://cdn.magicpatterns.com/uploads/wxDNAvuNy3WA4QLGGjbPf2/Bilqees_Helius_Originals.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/g8U24EmsLzDQQtgYTHotnV/helius.png',
    website: 'https://heliusoriginals.com/',
  },
  {
    id: '7',
    company: 'Fem Entity',
    founder: 'Mukisa Kakembo',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/fmDeYU6gFvTR3PZCmsqbcq/Mukisa.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/auzMKqvRw9msAY9MKikcTz/fementity.png',
    website: 'http://fementity.ca',
  },
  {
    id: '8',
    company: 'KnowMEDIQ',
    founder: 'Margarettha Pierre',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/vBrjnw6Yb7ovMorqfxTsC9/Margarettha.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/bFBZ5b7z1NTMCsXqoNjbhz/knowmedi---.png',
    website: 'https://knowmediq.ca/',
  },
  {
    id: '9',
    company: 'Kula Foods',
    founder: 'Asha Wheeldon',
    sector: 'Consumer & Food',
    image:
      'https://cdn.magicpatterns.com/uploads/dtH7YKxcyxWfNoBnmfvSKZ/AshaWheeldon.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/o2gQmFFcGwvP4jWfFoP9H9/Kula.png',
    website: 'https://kulafoods.ca/',
  },
  {
    id: '10',
    company: 'Juno',
    founder: 'Nanette Sene',
    sector: 'MedTech',
    image:
      'https://cdn.magicpatterns.com/uploads/ki5m5kJD3twSpbD1TsFksg/Nanette.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/qkw7rn5Mea7vzRX2UgUQJg/juno---.png',
    website: 'https://junotechno.com/',
  },
  {
    id: '11',
    company: 'LiiT Care Connect',
    founder: 'Lulu Mashonganyika',
    sector: 'SaaS',
    image:
      'https://cdn.magicpatterns.com/uploads/ev3amjvK62Ry7TqJrTBVae/Lulu_LiitCareConnect.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/2cp9ceRL9jsrSrXfX74XN8/liitcareconnect.png',
    website: 'https://www.liitcare.com/',
  },
  {
    id: '12',
    company: 'OMA Life App',
    founder: 'Chioma Efejedia',
    sector: 'HealthTech',
    image:
      'https://cdn.magicpatterns.com/uploads/gMsu3yqnvFhS3U44Qf9hQt/Chioma.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/n1KU6zopDj5EKRePMHN6Ru/omalife.png',
    website: 'https://omalife.io/',
  },
  {
    id: '13',
    company: 'Seleste Security',
    founder: 'Sylienne Cardichon',
    sector: 'Defence Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/bnAuGfrw2BXDU49qrUn4wT/Sylienne.jpg',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/u3LazMKfwR3faKYaCJvg5h/selest.png',
    website: 'https://www.selestsecurity.com/',
  },
  {
    id: '14',
    company: 'TalentIQ',
    founder: 'Stephanie Martin',
    sector: 'Defence Tech',
    image:
      'https://cdn.magicpatterns.com/uploads/rWQvnukyeVRUJ9Kb1s5oRa/Stephanie_-_TALENT_IQ.png',
    imageType: 'headshot',
    logo: 'https://cdn.magicpatterns.com/uploads/bCHuuJinKqQh8vSvB3hqch/TalentIQ.png',
    website: 'https://talentiqtech.work/',
  },
]

export const sectors = [
  'All',
  ...Array.from(new Set(founders.map((f) => f.sector))).sort(),
]
